import { useState, useEffect } from 'react'
import api from '@api'
import ImportSummary from '../ImportSummary'
import { ApolloError } from 'apollo-boost'

interface ImportSummary {
  totalCount: number
  createdCount: number
  updatedCount: number
  destroyedCount: number
  failedCount: number
  seatedCount: number
}

interface ImportSummaryHook {
  loading: boolean
  summary: ImportSummary
  error: ApolloError | null
}

export default function useImportSummary(id: string) {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<ApolloError | null>(null)
  const [summary, setSummary] = useState({
    totalCount: 0,
    createdCount: 0,
    updatedCount: 0,
    destroyedCount: 0,
    failedCount: 0,
    seatedCount: 0,
  })

  useEffect(() => {
    api.employee.import
      .summary(id)
      .then((summary) => {
        setLoading(false)
        setSummary(summary)
      })
      .catch((error) => {
        setError(error)
        setLoading(false)
      })
  }, [id])

  return { loading, error, summary }
}
